<template>
	<LoginLayout
		form-title="SSO logout"
	>
		<template #form>
			<Message type="info">
				You have been logged out successfully.
			</Message>
			<a @click="$router.push({ path: '/login' })">
				Log in.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../../../../shared/layouts/login-layout.vue'
import Message from '../../../../shared/components/message.vue'
export default {
	components: { Message, LoginLayout }
}
</script>
